var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoThumbnail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#707070",
  d: "M20.411 10.685V21.35H7.078V10.685zm1.333-2.667h-16c-.733 0-1.333.6-1.333 1.333v13.334c0 .733.6 1.333 1.333 1.333h16c.734 0 1.334-.6 1.334-1.333v-4.667l5.333 5.333V8.685l-5.333 5.333V9.351c0-.733-.6-1.333-1.334-1.333"
})));
export { SvgVideoThumbnail as ReactComponent };
export default __webpack_public_path__ + "27a82ee8f40c8a96678df0e17f2ad9fd.svg";